import {StoreObj} from './store-obj';

export class SearchInStoreRequest {
  store: StoreObj;
  text: string;

  constructor(store: StoreObj, text: string) {
    this.store = store;
    this.text = text;
  }
}
